import {
  CHANGE_TABS,
  RESET_ADMIN_PROFILE_IMG,
  SET_ERROR_MSG,
  SET_IS_EDIT_SUCCESS,
  SET_IS_PROFILE_INFO_EDIT_SUCCESS,
  SET_PASSWORD_ERROR_MESSAGE,
  SET_TABS,
} from './AccountSettingsConstants'

export const resetAdminProfile = () => ({
  type: RESET_ADMIN_PROFILE_IMG,
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsEditSuccess(newStatus) {
  return {
    type: SET_IS_EDIT_SUCCESS,
    payload: newStatus,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsProfileInfoEditSuccess(newStatus) {
  return {
    type: SET_IS_PROFILE_INFO_EDIT_SUCCESS,
    payload: newStatus,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setAdminError = (newStatus) => ({
  type: SET_ERROR_MSG,
  payload: newStatus,
})

export const setTabs = () => ({
  type: SET_TABS,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function changeTabs(title) {
  return {
    type: CHANGE_TABS,
    payload: title,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPasswordErrorMessage = (message) => ({
  type: SET_PASSWORD_ERROR_MESSAGE,
  payload: message,
})
